import React, { useState } from "react";
import { Link } from "react-router-dom";
// const firebase = require("firebase");
// import firebase from 'firebase';
// import "firebase/firestore";
import { handleSubmitEmail } from "./App";

var validator = require("email-validator");
// var db = firebase.firestore();

export default function Landing() {
  const [value, setValue] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleChange = event => {
    setValue(event.target.value);
  };

  const handleSubmit = () => {
    handleSubmitEmail(value, setSubmitted);
  };

  return (
    <div style={styles.app}>
      <header style={styles.firstPage}>
        <img
          src={require("./assets/stryvelogo.png")}
          style={{ height: 40, marginTop: 45 }}
        />
        {/* <Link to="/login">Login</Link> */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            alignItems: "center"
          }}
        >
          <div style={{ height: 60 }} />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: 120
              }}
            >
              <p
                style={{
                  fontSize: 35,
                  fontFamily: "AvenirNext-DemiBold",
                  color: "#323232",
                  // textAlign: "center",
                  maxWidth: 500
                }}
              >
                Replace Phone Screens With Short Form Video
              </p>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div
                  style={{
                    width: 335,
                    display: "flex",
                    flexDirection: "column",
                    height: 45,
                    backgroundColor: "#F9F9F9",
                    borderTopLeftRadius: 5,
                    borderBottomLeftRadius: 5,
                    marginLeft: 35,
                    paddingLeft: 15
                    // marginTop: 4
                  }}
                >
                  <input
                    placeholder="Email"
                    type="text"
                    value={value}
                    onChange={handleChange}
                    style={{
                      height: 45,
                      // marginLeft: 15,
                      backgroundColor: "#F9F9F9",
                      width: 320,
                      fontSize: 22,
                      borderWidth: 0,
                      fontFamily: "AvenirNext-Medium",
                      outline: "none",
                      color: "#323232"
                    }}
                  />
                </div>
                <div
                  onClick={handleSubmit}
                  style={submitted ? styles.submittedButton : styles.button}
                >
                  <div
                    style={
                      submitted
                        ? styles.submittedButtonLabel
                        : styles.buttonLabel
                    }
                  >
                    {submitted ? "Request Sent" : "Request Access"}
                  </div>
                </div>
              </div>
            </div>
            <div style={{ width: 120 }} />
            <div
              style={{
                borderRadius: 30,
                padding: 16,
                boxShadow: "0px 8px 36px rgba(75, 85, 173, 0.2)"
              }}
            >
              <div
                style={{
                  borderRadius: 20,
                  overflow: "hidden",
                  // backgroundColor: "red",
                  height: 600,
                  width: 275,
                  display: "flex",
                  flexDirection: "column"
                }}
              >
                <img
                  style={{ objectFit: "cover" }}
                  src="https://stryve-video-image-store.s3-us-west-1.amazonaws.com/videos/smalldemo.gif"
                  height="600"
                  width="275"
                />
              </div>
            </div>
          </div>
          <div style={{ height: 90 }} />
          {/* <input
            placeholder="Email"
            type="text"
            value={value}
            onChange={handleChange}
            style={{
              height: 50,
              width: 320,
              fontSize: 22,
              borderWidth: 0,
              fontFamily: "AvenirNext-Medium",
              outline: "none",
              color: "#323232",
              borderRadius: 5
            }}
          /> */}
          {/* <div style={{ height: 1, backgroundColor: "#B7B7B7", width: 340 }} /> */}
        </div>
      </header>
      <div style={{ height: 40 }} />
      <CopySection
        title="Ask The Right Questions Once"
        subtitle="Record once. Standardize questions across all candidates."
        source={require("./assets/peopleList.png")}
        imageWidth={1784 / 4}
        imageHeight={1312 / 4}
      />
      <CopySection
        title="Hire Faster As A Team"
        subtitle="Your whole team can give input."
        source={require("./assets/collabList.png")}
        imageWidth={1784 / 4}
        imageHeight={1532 / 4}
      />
      <CopySection
        title="Hire People. Not Resumes."
        subtitle="Resumes never tell the full story. Make informed 
  decisions - without compromising speed."
        source={require("./assets/phonecam.png")}
        imageWidth={1000 / 2.2}
        imageHeight={1200 / 2.2}
      />
      <div style={{ height: 100 }} />
    </div>
  );
}

function CopySection({ title, subtitle, source, imageWidth, imageHeight }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        alignSelf: "center",
        justifyContent: "space-between",
        width: 1200,
        marginTop: 100
      }}
    >
      <div
        style={{
          width: 600,
          flexDirection: "column",
          alignItems: "center",
          display: "flex"
        }}
      >
        <img src={source} style={{ height: imageHeight, width: imageWidth }} />
      </div>
      <div style={{ paddingLeft: 50 }}>
        <p style={styles.header}>{title}</p>
        <div
          style={{ width: 600, flexDirection: "column", alignItems: "center" }}
        >
          <p style={styles.subtitle}>{subtitle}</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  header: {
    fontSize: 35,
    fontFamily: "AvenirNext-DemiBold",
    color: "#323232",
    textAlign: "center",
    maxWidth: 700
  },
  subtitle: {
    fontSize: 24,
    fontFamily: "AvenirNext-Medium",
    color: "#808080",
    textAlign: "center",
    maxWidth: 800,
    marginTop: 0
  },
  firstPage: {
    backgroundColor: "#FFFFFF",
    // paddingTop: 30,
    display: "flex",
    // height: '100vh',
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between"
  },
  container: {
    backgroundColor: "#FFFFFF",
    display: "flex",
    height: "100vh",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  app: {
    display: "flex",
    flexDirection: "column",
    flex: 1
  },
  buttonLabel: {
    fontSize: 18,
    fontFamily: "AvenirNext-DemiBold",
    color: "white"
  },
  submittedButtonLabel: {
    fontSize: 18,
    fontFamily: "AvenirNext-DemiBold",
    color: "#4F60FA"
  },
  button: {
    height: 45,
    width: 190,
    backgroundColor: "#4F60FA",
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    boxShadow: "0px 8px 36px rgba(75, 85, 173, 0.2)"
    // marginTop: 50
  },
  submittedButton: {
    height: 45,
    width: 190,
    backgroundColor: "white",
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    borderWidth: 2,
    borderColor: "#4F60FA",
    borderStyle: "solid",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    // marginTop: 50,
    boxSizing: "border-box"
  }
};
